import { Component } from '@angular/core';

@Component({
    selector: 'fap-resources-table',
    templateUrl: './fap_resources-table.component.html',
    styleUrls: ['./fap_resources-table.component.scss']
})
export class FapResourcesTableComponent {}
